import { Arrow, SelectListWrapper } from 'components/ui/SelectList/SelectListStyles';
import styled from 'styled-components';
import { borderColorNotes, brand, grey, white } from 'styles/Colors';

export const Suggestion = styled.div``;

export const TextareaWrapper = styled.div`
  position: relative;
  font-size: 13px;
`;

export const StyledTextarea = styled.textarea`
  outline: none;
  resize: none;
  border: none;
  width: 290px;
  padding: auto;
`;

export const Placeholder = styled.div`
  top: 0;
  position: absolute;
  height: 100%;
  width: 290px;
  background: ${white};
  display: flex;
`;

export const PlaceholderText = styled.div`
  position: relative;
  margin: auto 0;
  overflow-wrap: break-word;
  width: 100%;
  .grey {
    color: ${grey};
  }
`;

export const NotesWrapper = styled.div`
  display: flex;
  position: relative;
  font-family: Lato;
  height: 100%;
  align-items: center;
  &.disabled {
    cursor: default;
    svg {
      cursor: default;
      path {
        fill: ${grey};
      }
    }
  }

  .edit-icon {
    transform: scale(0.8);
    margin-right: 5px;
  }

  .expand-icon {
    transform: rotate(180deg);
    cursor: pointer;
  }

  ${SelectListWrapper} {
    position: absolute;
    width: 332px;
    user-select: none;
    bottom: 80px;
    right: -3px;
    padding: 0;
    z-index: 999;
    ${Suggestion} {
      font-size: 15px;
      border-bottom: 1px solid ${borderColorNotes};
      height: 47px;
      display: flex;
      align-items: center;
      padding-left: 16px;
      &:hover {
        color: ${brand};
        cursor: pointer;
      }
      &:last-child {
        border-bottom: none;
      }
    }
    ${Arrow} {
      bottom: -10px;
      top: auto;
      border-width: 10px 10px 0 10px;
      border-color: ${white} transparent transparent transparent;
    }
  }
`;
